export default "__VITE_ASSET__XMlmha5J__"